<template>
  <el-dialog
    :visible.sync="visible"
    class="dialog-style"
    title="檢舉"
    append-to-body
    :show-close="true"
    :center="true"
  >
    <div class="radio-container">
      <div>
        選擇檢舉理由
      </div>
      <div
        v-for="r in defaultReason"
        :key="r"
        class="radio"
      >
        <i
          class="pointer"
          :class="reason === r ? 'checked' : ''"
          @click="reason=r"
        />
        <span
          class="pointer"
          @click="reason=r"
        >{{ r }}</span>
      </div>
      <div
        class="textarea-container"
        :class="showTextarea ? '' : 'hidden-area'"
      >
        <textarea
          class="textarea"
          v-model="textareaText"
          @click="stopPro($event)"
          placeholder="點擊輸入..."
        >
        </textarea>
        <div 
          v-show="showTextarea"
        class="letter-num"
        >
          <span :class="textareaText.length > textareaTextMaxLength ? 'light' : ''">{{ textareaText.length }}</span>/{{ textareaTextMaxLength }}
        </div>
      </div>
      <div class="page-title">請上傳圖片證據<span class="tip-text">(必填，請上傳最多5張清晰的關聯材料)</span></div>
      <div class="photo-wrap">
        <div
          v-for="(url, i) in imgList"
          :key="`photo-${i}`"
          :class="addIndex === i && 'add-photo pointer'"
          :style="{
            backgroundImage: ((url || addIndex === i) ? `url('${ addIndex === i ? addImage : url}')` : ''),
            zIndex: imgList.length - i
          }"
        >
          <el-upload
            v-if="addIndex === i"
            class="upload-image"
            action="*"
            accept="image/png,image/jpg,image/gif,image/jpeg,image/webp"
            :show-file-list="false"
            :before-upload="beforeImageUpload"
            :http-request="handleImageSuccessChange"
          />
          <div
            v-else-if="url"
            class="delete-img pointer"
            @click.stop="deleteImage(i)"
          >
            <img src="~@/assets/image/icons/close-white.png">
          </div>
        </div>
      </div>
      <div class="buttons">
        <div
          class="normal-btn pointer"
          @click="visible=false"
        >取消</div>
        <div
          class="primary-btn pointer"
          :class="(hasReason && imageList.length) ? '' : 'dis-click'"
          @click="emitReason"
        >提交</div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import addImage from '@/assets/image/icons/add-gray.png'
import { uploadFileToS3 } from '@/api'
export default {
  name: 'Impeach',
  data() {
    const addIndex = 0
    const imgList = new Array(5).fill('')
    return {
      visible: true,
      reason: '',
      defaultReason: [
        '發送虛假與有害信息騷擾用戶',
        '虛假個人資料',
        '利用違規手段下單或接單',
        '陪玩師不接單',
        '發布違規約單內容',
        '惡意刷單',
        '其他違規行為',
      ],
      textareaText: '',
      textareaTextMaxLength: 200,
      imgList,
      addIndex,
      addImage,
    }
  },
  computed: {
    imageList() {
      if (!this.addIndex) {
        return []
      }
      return this.imgList.slice(0, this.addIndex)
    },
    showTextarea() {
      let defaultReason = this.defaultReason
      return (defaultReason[defaultReason.length - 1] === this.reason)
    },
    hasReason() {
      return this.reason && !this.showTextarea || this.showTextarea && this.textareaText.replace(/\s/g, '')
    }
  },
  watch: {
    visible(value) {
      if(!value) return
      this.defaultData()
    }
  },
  methods: {
    deleteImage(index) {
      this.imgList.push('')
      this.addIndex = this.addIndex - 1
      this.imgList.splice(index, 1)
    },
    defaultData() {
      this.reason = ''
      this.textareaText = ''
      const addIndex = 0
      const imgList = new Array(5).fill('')
      this.addIndex = addIndex
      this.imgList = imgList
    },
    addPic(src) {
      const { imgList, addIndex } = this
      if (addIndex >= imgList.length - 1) {
        this.$set(imgList, addIndex, src)
      } else {
        imgList[addIndex] = src
      }
      this.addIndex = addIndex + 1
    },
    // 添加图片
    handleImageSuccessChange({ file }){
      const fd = new FormData()
      fd.append('file', file)
      if(!this.loading) {
        this.loading = true
        uploadFileToS3(fd).then(({data}) => {
          this.addPic(data)
          this.loading = false
        })
      }
      
    },
    //圖片上傳以前的鉤子函數
    beforeImageUpload(file){
      console.log(file, file.naturalWidth, file.width)
      const { type, size } = file
      const fileTypeList = ['image/gif', 'image/jpeg', 'image/jpg', 'image/png', 'image/webp']

      if (!fileTypeList.includes(type.toLowerCase())) {
        this.$message.error('上传图片只能是 JPG/JPEG/PNG/GIF/WEBP 格式!')
        return Promise.reject()
      }

      if (size > 1024 * 1024 * 3) {
        this.$message.error('上传头像图片大小不能超过 3MB!')
        return Promise.reject() 
      }

      return new Promise((resolve) => {
        const fileReader = new FileReader()

        fileReader.readAsDataURL(file)

        fileReader.onload = () => {
          const img = new Image()

          img.onload = () => {
            return resolve()
          }

          img.src = fileReader.result
        }
      })
    },
    stopPro(e) {
      e = e || window.event
      e.stopPropagation ? e.stopPropagation() : (e.cancelBubble = true)
    },
    emitReason() {
      if (!this.hasReason) {
        this.$message.error('請選擇檢舉內容')
        return
      }
      if (this.showTextarea && (this.textareaText.length > this.textareaTextMaxLength)) {
        this.$message.error('檢舉內容不能超過200字')
        return
      }
      if (!this.imageList.length) {
        this.$message.error('請上傳關聯圖片')
        return
      }
      let reportReason = this.showTextarea ? this.textareaText : this.reason
      this.$http.post('/user/report', {
        reportReason,
        reportedUuid: this.$data.reportedId,
        imageList: this.imageList,
      }).then(rs => {
        if(rs.success) {
          this.$message({
            message: '已成功提交檢舉，我們會儘快審核您的檢舉。',
            type: 'success'
          })
        } else {
          this.$message.error('檢舉失敗')
        }
      }).catch(() => {
        this.$message.error('網絡忙')
      })
      this.visible = false
    }
  }
}
</script>
<style lang="scss">
  .upload-image {
    width: 100%;
    height: 100%;
    div {
      width: 100%;
      height: 100%;
    }
  }
</style>
<style lang="scss" scoped>
.page-title {
  margin-top: 30px;
}
.photo-wrap {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  &>div {
    width: 72px;
    height: 72px;
    border-radius: 8px;
    box-sizing: border-box;
    background: no-repeat center center / cover;
    position: relative;
  }
  .add-photo {
    border: 1px dashed #CCCCCC;
    background-size: 24px;
  }
  .delete-img {
    position: absolute;
    top: -10px;
    right: -9px;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #333333;
    img {
      width: 12px;
    }
  }
}
.tip-text {
  font-size: 14px;
  line-height: 20px;
  color: #999999;
}
.light {
  color: #FA006E;
}
.dis-click {
  background: #EEE !important;
}
.pointer {
  cursor: pointer;
}
.container {
  position: absolute;
  width: 100vw;
  height: 100vh;
  background: #000;
  top: 0;
  left: 0;
}
.radio-container {
  display: flex;
  flex-direction: column;
  font-size: 14px;
  line-height: 20px;
  color: #222;
  .radio {
    display: flex;
    margin-top: 20px;
    i {
      width: 20px;
      height: 20px;
      box-sizing: border-box;
      border: 1px solid #CCC;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 8px;
    }
    i::after {
      content: '';
      width: 10px;
      border-radius: 50%;
      height: 10px;
      font-size: 0;
    }
    i.checked::after {
      background: #FA006E;
    }
  }
  .textarea {
    width: 100%;
    height: 100%;
    resize: none;
    box-sizing: border-box;
    padding: 12px 15px;
    font-size: 12px;
    line-height: 17px;
    border: 1px solid #CCC;
    border-radius: 5px;
  }
  .textarea-container {
    margin-top: 10px;
    height: 134px;
    transition: all .3s;
    position: relative;
    .letter-num {
      font-size: 12px;
      line-height: 16px;
      color: #9D9D9D;
      position: absolute;
      bottom: 8px;
      right: 10px;
    }
  }
  .hidden-area {
    height: 0px;
    margin-top: 0px;
    overflow: hidden;
  }
  .buttons {
    margin-top: 36px;
    display: flex;
    div {
      height: 46px;
      border-radius: 4px;
      line-height: 46px;
      text-align: center;
    }
  }
}
@media screen and(min-width: 600px) {
  .radio-container {
    .textarea-container {
      margin-left: 30px;
    }
    .buttons {
      justify-content: flex-end;
      div {
        width: 100px;
      }
      .primary-btn {
        margin-left: 10px;
      }
    }
  }
  .dialog-style {
    & /deep/ .el-dialog{
      width: 500px;
      border-radius: 8px;
    }
  }
}
@media screen and(max-width: 599px) {
  .radio-container {
    .buttons {
      justify-content: canter;
      div {
        flex: 1;
      }
      .primary-btn {
        margin-left: 15px;
      }
    }
  }
  .dialog-style {
    & /deep/ .el-dialog{
      position: fixed;
      bottom: 0;
      margin: 0 !important;
      left: 0;
      width: 100%;
      box-sizing: border-box;
      max-height: 80%;
      border-radius: 20px 20px 0 0;
      max-height: 100%;
      overflow-y: auto;
      /deep/ .el-dialog__body {
        padding-bottom: 76px;
      }
    }
  }
}
</style>